// @flow
import React, { useCallback } from 'react';
import type { Node } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import map from 'lodash/map';
import SelectField from '../../../../common/components/select-field';
import { ACTION_SELECT_FIELD_ON_CHANGE } from '../../form-submitter-context/form-submitter-constant';
import { useFormSubmitterContext } from '../../form-submitter-context';
import RequiredMark from '../../../../common/components/required-mark';

import type { SelectFieldElement } from '../../../../types/form/Element';

type Props = {
  description?: Node,
  element: SelectFieldElement,
};

const SelectFieldWithContext = (props: Props) => {
  const { element, description } = props;
  const { id, label, required, options = [], multiSelect } = element;
  const {
    state,
    dispatch,
    selector: { getSelectedValuesForId, getErrorForId },
  } = useFormSubmitterContext();
  const values = getSelectedValuesForId(state, id);
  const error = getErrorForId(state, id);
  const { submitInProgress } = state;
  const isDisabled = submitInProgress;
  const onChange = useCallback(
    newValues => {
      dispatch({
        id,
        type: ACTION_SELECT_FIELD_ON_CHANGE,
        newValues: map(newValues, newValue => newValue.value),
      });
    },
    [dispatch, id],
  );
  const renderLabel = required ? (
    <>
      {label} <RequiredMark />
    </>
  ) : (
    label
  );
  return (
    <SelectField
      description={description}
      error={error && <FormattedMessage {...error} />}
      isDisabled={isDisabled}
      isMultiple={multiSelect}
      isRequired={required}
      label={renderLabel}
      onChange={onChange}
      options={options}
      selectedValues={values}
    />
  );
};

export { SelectFieldWithContext };
export default injectIntl(SelectFieldWithContext);
